import type { ReactNode } from 'react';
import { ProfessionalSummaryDataTable } from '@frontend/components/pages/professionalSummaryData/ProfessionalSummaryDataTable';
import { TableBody, TableHead, TableHeader, TableRow } from '../../../../../elements/common';
import { MedicationsTableHeader } from './MedicationsTableHeader';

interface IMedicationsPickableTableProps {
    tableRows: ReactNode[];
}

export function MedicationsPickableTable(props: IMedicationsPickableTableProps) {
    return (
        <>
            <ProfessionalSummaryDataTable>
                <TableHead>
                    <TableRow>
                        <TableHeader className="has-checkbox"></TableHeader>
                        <MedicationsTableHeader />
                    </TableRow>
                </TableHead>
                <TableBody>{props.tableRows}</TableBody>
            </ProfessionalSummaryDataTable>
        </>
    );
}
